import { createAction } from 'Lib/reduxUtils';

import type { Paywall } from 'Store/entities/paywalls.types';

import { GET_OFFER_PAYWALLS, GET_OFFER_PAYWALLS_SUCCESS } from './constants';
import type { OfferPaywallsPayload } from './types';

export const getOfferPaywalls = createAction(
  GET_OFFER_PAYWALLS,
  (payload: OfferPaywallsPayload) => payload
);

export const getOfferPaywallsSuccess = createAction(
  GET_OFFER_PAYWALLS_SUCCESS,
  (payload: Paywall[]) => payload
);
